import { HomeUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

export const fetchMe = () => {
  return new HomeUseCase('/me', makeAxiosHttpClient())
}

export const updateMe = () => {
  return new HomeUseCase('/me/update', makeAxiosHttpClient())
}
